/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']['input'];
}>;

export type IAppQuery = {
  __typename?: 'Query';
  app: {
    __typename?: 'App';
    id: string;
    name?: string | null;
    description?: string | null;
    logoUrl?: string | null;
    criticality?: Types.AppCriticalityEnum | null;
    industry?: string | null;
    jurisdiction?: string | null;
    softwareType?: string | null;
    kind: Types.AppKindEnum;
    owned: boolean;
    ownerName: string;
    ownerWebsite?: string | null;
    unclaimed: boolean;
    includedApps?: Array<string> | null;
    createdAt: any;
    updatedAt: any;
    creator?: { __typename?: 'User'; name?: string | null } | null;
    taskCounts: Array<{ __typename?: 'TaskCount'; criticality: Types.TaskCriticalityEnum; count: number }>;
    policy: {
      __typename?: 'AppPolicy';
      read: boolean;
      update: boolean;
      createBackup: boolean;
      createEscrow: boolean;
      createCustodianProfile: boolean;
      createMemberships: boolean;
      linkProducts: boolean;
      readMemberships: boolean;
      remove: boolean;
    };
  };
};

export const AppDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'app' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'app' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'softwareType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'owned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerWebsite' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unclaimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'includedApps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taskCounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createBackup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createEscrow' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createCustodianProfile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createMemberships' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkProducts' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readMemberships' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppQuery, IAppQueryVariables>;
